import React from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/timesheetActions';
import { XMarkIcon } from '@heroicons/react/20/solid'

const ImagePreviewModal = ({
    imagePreview,
    timesheetImagePreviewModal
}) => {

    if(!imagePreview.isModalOpen) return null;

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ overflow: "auto", display: "block", background: "rgba(0,0,0,0.4)" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b">
                        <div className="block-header bg-primary-dark">
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={() => timesheetImagePreviewModal({ status: false })}>
                                        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                                    </button>
                                </li>
                            </ul>
                            <h3 className="block-title">Image Preview</h3>
                        </div>
                        <img style={{ maxWidth: "100%" }} src={imagePreview.openFile.url} alt="Preview Of Timesheet Import" />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {

    return {
        imagePreview: state.timesheets.imagePreview
    }
}

const mapDispatchToProps = dispatch => ({
    timesheetImagePreviewModal: ({ status }) => dispatch(ACTIONS.timesheetImagePreviewModal({ status })),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImagePreviewModal)